import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import CustomCheckbox from '../../../common/components/CustomCheckbox';
import CurrencyUtility from '../../../common/utility/CurrencyUtility';

export default function KaraokeRegistrationStartFormView1({
  isBeforePayment,
  paymentAmount,
  onNext,
} : {
  isBeforePayment: boolean,
  paymentAmount: number,
  onNext: () => void,
}) {
  const [agreement1, setAgreement1] = React.useState(false);
  const [agreement2, setAgreement2] = React.useState(false);

  return (
    <form>
      <div className="form__body">
        <dl>
          <dd>
            <CustomCheckbox
              checked={agreement1}
              setChecked={(checked) => setAgreement1(checked)}
            >
              この曲は現在JASRACなどの著作権管理団体に信託していません。
            </CustomCheckbox>
            <CustomCheckbox
              checked={agreement2}
              setChecked={(checked) => setAgreement2(checked)}
            >
              {isBeforePayment
                ? `変更後の料金${CurrencyUtility.format(paymentAmount + 5000)}円を銀行振込で支払います。`
                : '著作権管理委託の手数料として5,000円を支払います。'}
            </CustomCheckbox>
          </dd>
        </dl>
        <p className="top_line" />
        <ul>
          <li className="bt">
            <CustomButton type="default" disabled={!(agreement1 && agreement2)} onClick={() => onNext()}>同意して変更</CustomButton>
          </li>
        </ul>
      </div>
    </form>
  );
}
